import { render, staticRenderFns } from "./SetSocialSites.vue?vue&type=template&id=786494da&scoped=true&"
import script from "./SetSocialSites.vue?vue&type=script&lang=js&"
export * from "./SetSocialSites.vue?vue&type=script&lang=js&"
import style0 from "./SetSocialSites.vue?vue&type=style&index=0&id=786494da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786494da",
  null
  
)

export default component.exports